import Component from './applicant_grid.vue'
export default Component
